<template>
  <div
    class="anonymous_complaint_modal modal"
    v-if="$store.state.main.anonymous_complaint_modal"
  >
    <div class="phone_modal__overlay bg-overlay" @click="close_modal"></div>
    <div
      class="anonymous_complaint_modal__inner bg-white"
      :class="{ mob_100: windowWidth <= 767 }"
    >
      <div class="anonymous_complaint_modal__ttl_wrapper flex j_sb a_center">
        <h2 class="f-24 bold uppercase">{{ content.title }}</h2>
        <div
          class="anonymous_complaint_modal__x_btn pointer"
          @click="close_modal()"
        >
          <svg
            id="Group_4238"
            data-name="Group 4238"
            xmlns="http://www.w3.org/2000/svg"
            width="16.971"
            height="16.971"
            viewBox="0 0 16.971 16.971"
          >
            <rect
              id="Rectangle_543"
              data-name="Rectangle 543"
              width="20"
              height="4"
              rx="2"
              transform="translate(2.828 0) rotate(45)"
            />
            <rect
              id="Rectangle_1219"
              data-name="Rectangle 1219"
              width="20"
              height="4"
              rx="2"
              transform="translate(16.971 2.829) rotate(135)"
            />
          </svg>
        </div>
      </div>

      <div
        class="anonymous_complaint_modal__editor"
        v-html="content.content"
      ></div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import fix_100_vh_android from "@/mixins/fix_100_vh_android";
export default {
  props: ["content"],
  mixins: [resize_handler, fix_100_vh_android],

  methods: {
    close_modal() {
      document.querySelector(".modal").classList.remove("modal_active");
      setTimeout(() => {
        this.$store.state.main.anonymous_complaint_modal = !this.$store.state
          .main.anonymous_complaint_modal;
      }, 701);
    }
  },
  computed: {
    anonymous_complaint_modal() {
      return this.$store.state.main.anonymous_complaint_modal;
    }
  },

  watch: {
    $route(to, from) {
      if (this.$store.state.main.anonymous_complaint_modal) {
        this.$store.state.main.anonymous_complaint_modal = !this.$store.state
          .main.anonymous_complaint_modal;
      }
    },

    anonymous_complaint_modal(ns, os) {
      if (ns == true) {
        setTimeout(() => {
          document
            .querySelector(".anonymous_complaint_modal")
            .classList.add("modal_active");
        }, 10);
      }
      if (this.windowWidth <= 767) {
        ns == true
          ? document.querySelector("body").classList.add("modal-open")
          : document.querySelector("body").classList.remove("modal-open");
        ns == true
          ? document.querySelector("html").classList.add("modal-open")
          : document.querySelector("html").classList.remove("modal-open");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.anonymous_complaint_modal__editor {
  &::v-deep {
    p,
    span,
    h2,
    h3,
    h4,
    h5,
    h6,
    ul,
    li,
    a {
      font-family: "TBCSailec-Medium";

      font-size: 16px;
      line-height: 24px;
    }
    a {
      text-decoration: underline;
      text-decoration-color: #00adef;
    }
    ul {
      list-style-type: none;
      padding-left: 25px;
      @media (max-width: 767px) {
        padding-left: 52px;
      }
      @media (max-width: 413px) {
        padding-left: 32px;
      }
    }
    li {
      position: relative;
      &:after {
        position: absolute;
        left: 0;
        top: 9px;

        content: "";

        font-weight: bold;
        display: inline-block;
        width: 8px;
        height: 8px;
        margin-left: -22px;

        background-color: #7063e9;
        border-radius: 50%;
      }
    }
    strong {
      font-family: "TBCSailec-Bold";

      font-size: 16px;
      line-height: 24px;
    }
  }
}
</style>
